
import { Swiper, SwiperSlide } from 'swiper/react';

import { Autoplay, Navigation } from 'swiper/modules';
import PRC from "../../assets/PRCFULL.png"
import Paymob from "../../assets/Paymob.png"
import 'swiper/css/grid';
import { Link } from 'react-router-dom';
const Collaborations = () => {
    const slidesData = [
        {
            id: 1,
            image: PRC,
            url :"https://powersresources.com/en"
        },
        {
            id: 2,
            image: Paymob,
            url :"https://www.paymob.com"
        },
        {
            id: 3,
            image: PRC,
            url :"https://powersresources.com/en"
        },
        {
            id: 4,
            image: Paymob,
            url :"https://www.paymob.com"
        },
        {
            id: 3,
            image: PRC,
            url :"https://powersresources.com/en"
        },
        {
            id: 4,
            image: Paymob,
            url :"https://www.paymob.com"
        }
    ];


    return (
        <div className="bg-[#FAFAFB] sm:py-10 py-8">
            <div className="container  py-3">
                <div className="flex flex-col  lg:gap-12 gap-8">
                    <div className="max-w-[650px] mx-auto text-center">
                        <h1 className="text-secondary mb-3 font-semibold md:text-4xl sm:text-3xl text-2xl">Trusted By</h1>
                        <p className='sm:text-base text-sm '>At NileWise, we proudly collaborate with industry-leading partners to deliver exceptional solutions & enhance the value we provide to our clients.</p>
                    </div>
                    <div >
                    <Swiper
                    grabCursor={true}
                    navigation={{
                        nextEl: ".custom-next6",
                        prevEl: ".custom-prev6",
                    }}
                    loop={true}
                    slidesPerView={3}
                    spaceBetween={30}
                    autoplay={{
                        delay: 500,
                        disableOnInteraction: false,
                    }} 
                    modules={[Autoplay,  Navigation]}
                    speed={3000}
                    className="mySwiper"
                    breakpoints={{
                        0: {
                            slidesPerView: 2,
                            spaceBetween: 20,
                        },
                        450: {
                            slidesPerView: 2.6,
                            spaceBetween: 20,
                        },
                        550: {
                            slidesPerView: 3,
                            spaceBetween: 20,

                        },
                        660: {
                            slidesPerView: 4,
                            spaceBetween: 24,

                        },
                        850: {
                            slidesPerView: 5,
                            spaceBetween: 24,

                        },
                        1024: {
                            slidesPerView: 6,
                            spaceBetween: 28,
                
                        },
                    }}
                >
                    {slidesData.map(slide => (
                        <SwiperSlide key={slide.id} className="relative">
                            <Link target='_blank' to={slide.url} className="relative">
                                <img src={slide.image} className="relative w-full h-14" alt="" />
                            </Link>
                        </SwiperSlide>
                    ))}
                </Swiper>

                    </div>
                </div>
            </div>
        </div>
    )
}

export default Collaborations